import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { Stack, Typography } from '@mui/material';
import PaiIconButton from 'features/ui/base-components/pai-icon-button';
import PaiMenuItem from 'features/ui/base-components/pai-menu-item';
import PaiSelect from 'features/ui/base-components/pai-select';
import _ from 'lodash';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useBottomNodeMenuStore from 'stores/bottom-node-menu-store';
import { Shadows } from 'theme';
import { makeStyles } from 'tss-react/mui';
import usePromptLibrary from '../use-prompt-library';

interface Props {
  selectedFunnelFunctionsLibrary: string;

  handleSelectedFunnelFunctionsLibraryChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

const InitialFlowInstruction: React.FC<Props> = ({ selectedFunnelFunctionsLibrary, handleSelectedFunnelFunctionsLibraryChange }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const handleOpenMenu = useBottomNodeMenuStore((state) => state.handleOpenMenu);
  const { promptLibraryOptions } = usePromptLibrary();

  const btnRef = useRef(null);

  return (
    <Stack className={classes.initialFlowInstruction} justifyContent={'center'} alignItems={'center'} gap={3}>
      <Stack className={classes.instructionExample} justifyContent={'center'} alignItems={'center'}>
        <Stack className={classes.disabledAddIcon} justifyContent={'center'} alignItems={'center'}>
          <AddRoundedIcon />
        </Stack>
      </Stack>
      <Stack gap={2}>
        <Typography className={classes.formText} align={'center'}>
          {t('selectPromptLibrary')}
        </Typography>
        <Stack direction={'row'} justifyContent={'center'}>
          <PaiSelect
            value={_.isEmpty(promptLibraryOptions) ? '' : selectedFunnelFunctionsLibrary}
            variant={'background'}
            onChange={handleSelectedFunnelFunctionsLibraryChange}
            style={{ width: '300px', maxWidth: '100%' }}
          >
            {promptLibraryOptions.map((option) => (
              <PaiMenuItem key={option.value} value={option.value}>
                {t(option.label)}
              </PaiMenuItem>
            ))}
          </PaiSelect>
        </Stack>
        <Typography className={classes.formText} align={'center'}>
          {t('selectMessageOrCondition')}
        </Typography>
      </Stack>
      <PaiIconButton ref={btnRef} sx={{ position: 'absolute', bottom: '-56px' }} onClick={() => handleOpenMenu(btnRef.current)()}>
        <AddRoundedIcon />
      </PaiIconButton>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  initialFlowInstruction: {
    width: '350px',
    padding: '32px 0',
    background: '#FFF',
    borderRadius: '12px',
    boxShadow: Shadows.GREY_SHADOW_MAIN,
  },
  formText: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.greys.medium,
  },
  instructionExample: {
    position: 'relative',
    width: '95px',
    height: '65px',
    borderRadius: '12px',
    border: `2px dashed ${theme.palette.greys.lighter}`,
  },
  disabledAddIcon: {
    position: 'absolute',
    top: '-12px',
    padding: '2px',
    borderRadius: '50%',
    background: theme.palette.greys.lighter,
    '& svg': {
      fontSize: theme.typography.pxToRem(20),
      color: '#FFF',
    },
  },
}));

export default InitialFlowInstruction;
